// Profile.js
import React from 'react';
import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode';

const Profile = () => {
  const authToken = Cookies.get('authToken');
  let decodedToken = null;
  let role = '';
  let profileData = {};

  // Decode token and extract role/profile data
  if (authToken) {
    try {
      decodedToken = jwtDecode(authToken);
      role = decodedToken.claims?.role.toLowerCase() || '';
      profileData = {
        name: decodedToken.claims?.name || 'Guest',
        email: decodedToken.claims?.email || '',
        id: decodedToken.claims?.id || '',
        phoneNumber: decodedToken.claims?.phoneNumber || '',
        username: decodedToken.claims?.username || '',
        // Add more fields as needed from decodedToken
      };
    } catch (error) {
      console.error('Failed to decode token:', error);
    }
  }

  return { role, profileData, isAuthenticated: !!authToken };
};

export default Profile;
